import { take } from "rxjs/operators";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import type { MultiSelectChangeEvent } from "primeng/multiselect";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-slide-edit-shared-group-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './shared-group-form.component.html',
    styleUrls: ['./shared-group-form.component.scss'],
    standalone: false
})
export class SharedGroupFormComponent {
  #annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType | null;
  #groupIds: string[];
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((annotation) => {
      this.#annotation = annotation;
      this.#updateGroupIds();
    });
  }
  
  #updateGroupIds() {
    if (this.#annotation) {
      this.slideAuthorFacade.groupIdsByAnnotation$(this.#annotation.id).pipe(take(1)).subscribe((groupIds) => {
        this.#groupIds = groupIds;
      });
    } else {
      this.#groupIds = [];
    }
  }
  
  onChange(event: MultiSelectChangeEvent) {
    if (!this.#annotation) return;
    const groupsToAdd = event.value.filter((v: string) => !this.#groupIds.includes(v));
    const groupsToRemove = this.#groupIds.filter(v => !event.value.includes(v));
    
    if (groupsToAdd.length > 0) {
      this.slideAuthorFacade.requestAddAnnotationIdToGroups(groupsToAdd, this.#annotation.id, 'history.annotation_add_to_groups').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updateGroupIds()
      });
    } else if (groupsToRemove.length > 0) {
      this.slideAuthorFacade.requestRemoveAnnotationFromGroups(groupsToRemove, this.#annotation.id, 'history.annotation_remove_from_groups').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updateGroupIds()
      });
    }
  }
}
